"use strict";

(function () {
  'use strict';

  angular.module('lr.Loader').directive('lrLoader', ['$timeout', function ($timeout) {
    return function ($scope, element) {
      $scope.$on('loader_show', function () {
        return element.show();
      });
      $scope.$on('loader_hide', function () {
        $timeout(function () {
          element.hide();
        }, 600);
      });
    };
  }]);
})();